export interface DiscountContent {
  banner: string;
  subscription: string;
  discountCode?: string;
}
